import React, { useEffect } from 'react'
import { useParams } from 'react-router'
import UserRecord from './UserRecord'
import { Box, Card, Flex, Link, Loading, Message } from '@workwhile/ui'
import { useSearchUsers } from 'queries/user'
import { SearchBox, SearchParams } from './SearchBox'
import CollapsibleSection from 'components/Shared/CollapsibleSection'
import UserHeader from './UserHeader'

const Users = () => {
  // hooks to get and set url params
  const { keyword }: SearchParams = useParams<SearchParams>()
  const {
    data: users,
    error,
    refetch,
    isFetching,
  } = useSearchUsers({
    keyword: keyword ?? '',
    enabled: false, // trigger manually on click
  })

  useEffect(() => {
    if (keyword) {
      refetch()
    }
  }, [keyword])

  return (
    <Flex flexDirection="column" height="100vh">
      <SearchBox isLoading={isFetching} />
      {isFetching && !users ? (
        <Loading />
      ) : (
        <Box flex={1} overflow="auto">
          {error ? <Message variant="error">{error.message}</Message> : null}
          {!isFetching ? (
            <Message variant="info">
              {`Found ${users?.length ?? 0} result(s) matching "${keyword ?? ''}"`}
            </Message>
          ) : null}
          {(users ?? []).map((user, index) => (
            <CollapsibleSection
              key={user.id}
              title={<UserHeader user={user} />}
              defaultOpen={index === 0}
            >
              <Card backgroundColor="offWhite50" mt={1}>
                <Flex justifyContent="flex-end">
                  <Link to={`/user/${user.id}`}>Try the new user view →</Link>
                </Flex>
                <UserRecord search={refetch} user={user} />
              </Card>
            </CollapsibleSection>
          ))}
        </Box>
      )}
    </Flex>
  )
}

export default Users
